export const CONSOLATION_PRIZE_TEXT = "Incest and Shit with Grannies";

export const signupCopy = {
  heading: "FIFA World Cup 2026",
  matchLottery: {
    title: "Match Lottery",
    body: "Each participant will be assigned 1x2 lines for every match, plus some special bets. Points will be awarded based on the betting odds for each match, with additional multipliers for knockout stage games. No skill involved, excitement guaranteed for every game.",
  },
  matchLotteryPrizeDistribution:
    "Prize distribution: 50% for the winner, 30% for second place, 20% for third place.",
  matchLotteryEntryFee: "Entry fee: €50 per ticket, one ticket per person.",
  consolationPrize:
    'Consolation prize for the loser: a loan of the "Incest and Shit with Grannies" DVD until the next tournament.',
  winnerTeamLottery: {
    title: "Winner Lottery",
    body: "Each participant will be randomly assigned one of the top teams. The remaining teams will be randomly assigned to participants.",
  },
  winnerTeamLotteryEntryFee:
    "Entry fee: €20 per ticket, one ticket per person.",
  registration:
    "Registration: Register by transferring €20 (winner only), €50 (matches only), or €70 (winner+matches) with MobilePay to 050-5872087 or with a bank transfer to FI65 3939 0033 5711 42",
  seedLinkText:
    "The draw will be based on a deterministic algorithm and the seed will be the title of the first news article at yle.fi one hour before kickoff.",
  resultsAvailability: "The results page will be available after kickoff.",
  sneakPreviewLabel: "sneak preview",
} as const;

export const standingsCopy = {
  consolationPrizeFallback: CONSOLATION_PRIZE_TEXT,
} as const;
